<div class="container-fluid container-background">
    <div class="row">
    
        <!-- affixed header box sets padding for right menu -->
        <div class="col-xs-12 col-sm-6 col-md-5 col-lg-5 col-xl-4 bgwhite">
        
        <div class="outer">
        <div class="middle">
            
        <div class="login-form-container">
            
            
        <div class="login-header-title">
            <i class="zmdi zmdi-lock zdmi-fw"></i> Forgot password <span class="signupplan"></span>
        </div>
            
        <div *ngIf="sendsuccess" class="error-general-overlay error-general-overlay-login">
            <div class="row">
                <div class="col-xs-12"><i class="fas fa-check-circle"></i> A password hint has been sent to your email address {{forgotpasswordForm.value.email}}</div>
            </div>
        </div>
            
        <div *ngIf="resetSuccess" class="error-general-overlay error-general-overlay-login">
            <div class="row">
                <div class="col-xs-12">
                An email has been sent to {{forgotpasswordForm.value.email}} with further instructions.
                    
                <h1 [innerHtml]="resetCode"></h1>
                    
                This is your randomly generated code, you will need this to code to complete the password reset (write it down).
    
                </div>
            </div>
        </div>
  
  
    <sync-error-display-hash  [errors]="errors">
    </sync-error-display-hash>
        
        
    <form *ngIf="!validEmail" name="passhint" [formGroup]="forgotpasswordForm" (submit)="checkMethods($event)" ngNativeValidate>
        
        <div class="form-group" >
            <label for="exampleInputEmail1">Enter your email account:</label>
            <input
                type="email"
                placeholder="Email"
                formControlName="email"
                class="input-lg form-control login-form-control"
                id="forgot-password-hint-email"
                name="email"
            />
        </div>
        
        <button
        type="submit" [disabled]="forgotpasswordForm.invalid" class="btn-block btn btn-primary btn-lg btn-login-other">
        Submit <i [ngClass]="{'': emailCheckSpinner,
                'fa fa-spin fa-spinner': emailCheckSpinner}"></i>
        </button>
        
    </form>
            
    
                <div *ngIf="validEmail && !resetSuccess &&!sendsuccess">
                    <!-- <p>Password recovery options for: {{ctrl.email}}</p> -->
                    <div class="list-group">
                        <a class="syncblue list-group-item showhand"
                            (click)="emailResetSubmit()"
                            *ngIf="hasReset"
                        >
                            Reset my password via email <i class="fa"
                                [ngClass]="{'fa-spin fa-spinner': resetSpinner,
                                           'fa-chevron-right': !resetSpinner}"></i>
                            
                        </a>
                        <a class="syncblue list-group-item showhand"
                            (click)="emailHintSubmit()"
                            *ngIf="hasHint"
                        >
                            Send a password hint <i class="fa"
                                [ngClass]="{'fa-spin fa-spinner': hintSpinner,
                                   'fa-chevron-right': !hintSpinner}"></i>
                            
                        </a>
                        
                        <a class="syncblue list-group-item"
                            rel="noopener"
                            *ngIf="!hasReset && !hasHint"
                            href="https://www.sync.com/support/">
                            Contact us <i class="fa fa-chevron-right"></i>
                            
                        </a>
                        
                    </div>
                </div>
            
            
            
    
        <div class="login-link"><a class="syncblue showhand" routerLink="/login"><i class="zmdi zmdi-chevron-left zmdi-hc-lg"></i> Back to log in</a></div>
    
    
        
            
            </div> <!-- login form conteiner -->
            
            </div> <!-- middle -->
            </div> <!-- outer -->
        
        
        </div>
        <div class="hidden-xs col-sm-6 col-md-7 col-lg-7 col-xl-8">
            <!-- future -->
            
        </div>
            
          
    
    </div> <!-- row -->
    </div> <!-- /container -->